// The analytics reducer.
// @flow

import { combineReducers } from 'redux';

import { columns } from './reducers/columns';
import { config } from './reducers/config';
import { defaultSort } from './reducers/defaultSort';
import { metaTree } from './reducers/metaTree';
import { rows } from './reducers/rows';
import { title } from './reducers/title';
import { graphData } from './reducers/graphData';
import { kpi } from './reducers/kpi';
import { marketplaceProducts } from './reducers/marketplaceProducts';

export default combineReducers({
    columns,
    config,
    defaultSort,
    metaTree,
    rows,
    title,
    graphData,
    kpi,
    marketplaceProducts
});
